<template lang="pug">
    div.progressItem

        // Label
        div.progressLabel {{ label }}

        div.progressWrapper

            // Progress circle
            radial-progress-bar(
                :diameter="circleParams.diameter"
                :strokeWidth="circleParams.strokeWidth"
                :innerStrokeWidth="circleParams.innerStrokeWidth"
                :completed-steps="completedSteps"
                :total-steps="rating.value"
                :animateSpeed="2000"
                :isClockwise="true"
                innerStrokeColor="#ffffff"
                startColor="#7096D2"
                stopColor="#7096D2"
            )

            div.progressCounter {{ completed | numberWithCommas }} / {{ rating.value | numberWithCommas}}


            div.progressStarsWrapper
                v-tooltip(top color="transparent" content-class="progressTooltipWrapper")
                    template(v-slot:activator="{ on }")
                        div(v-on="on")
                            div.progressStars
                                div(v-for="index in 8" :key="`${label}-${index}`")
                                    v-icon(:color="iconColor(index)") star
                    div.progressTooltip
                        table
                            tr(v-for="(goal, index) in goals" :key="`${label}-${index}`")

                                td {{ `${goal} ${label} ` }}
                                td
                                    v-icon(
                                        v-for="n in (index + 1)"
                                        :key="`${goal}-${label}-${n}`"
                                        color="action"
                                    ) star
</template>

<script>
    import RadialProgressBar from 'vue-radial-progress';
    import Separator from '../Separator';
    import VueTypes from 'vue-types';
    import numberWithCommas from '~filters/numberWithCommas';

    export default {
        filters: { numberWithCommas },
        components: {
            RadialProgressBar,
            SeparatorComponent: Separator
        },
        props: {
            completed: VueTypes.number.def(0),
            label: VueTypes.string.def(''),
            totalSteps: VueTypes.number.def(0),
            goals: VueTypes.array.def([])
        },
        computed: {
            circleParams() {

                if (this.$vuetify.breakpoint.xsOnly) {
                    return {
                        diameter: 72,
                        strokeWidth: 3,
                        innerStrokeWidth: 3,
                        isMobile: true
                    };
                }

                if (this.$vuetify.breakpoint.smAndDown) {
                    return {
                        diameter: 86,
                        strokeWidth: 6,
                        innerStrokeWidth: 6,
                        isMobile: true
                    };
                }

                return {
                    diameter: 130,
                    strokeWidth: 10,
                    innerStrokeWidth: 10,
                    isMobile: false
                };
            },
            completedSteps() {
                if (this.completed > this.totalSteps) return this.totalSteps;
                return this.completed;
            },
            rating() {
                if (!this.goals.length) return 0;

                let res = { value: this.goals[0], index: null };
                for (let i = 0; i < this.goals.length; i++) {
                    if (this.completed >= this.goals[i] && this.completed > 0) {
                        res = { value: this.goals[i + 1], index: i };
                    } else {
                        break;
                    }
                }

                return res;
            }
        },
        methods: {
            iconColor(index) {
                if (this.rating.index === null) return '#ffffff';

                return index <= this.rating.index + 1 ? '#7096D2' : '#ffffff';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"
    @import "../../assets/style/_mixins.styl"

    .progressItem
        display: flex
        flex-direction: column
        align-items: center
        margin: 0 30px


    .progressLabel
        font-size: 13px
        text-transform: uppercase

    .progressWrapper
        padding: 7px
        margin: 40px 20px
        background-color: rgba(255, 255, 255, 0.1)
        border-radius: 50%
        position: relative

    .progressCounter
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        font-size: 14px
        white-space: nowrap

    .progressTooltip
        background-color: $theme.white
        color: $theme.primary
        border-radius: 10px
        padding: 5px
        position: relative

        &:before
            content: ''
            width: 0
            height: 0
            position: absolute
            bottom: -8px
            left: calc(50% - 6px)
            border-style: solid
            border-width: 10px 6px 0 6px
            border-color: #ffffff transparent transparent transparent

    .progressTooltipWrapper
        box-shadow: none

    .progressStarsWrapper
        position: absolute
        top: -21px
        left: -21px

    .progressStars
        on-circle($item-count: 8, $circle-size: 184px, $item-size: 20px);

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .progressItem
            padding: 0
            margin: 0

            >>> .v-rating i
                padding: 4px

        .progressTotal
            font-size: 40px
            font-weight: 300

        .progressWrapper
            padding: 4px
            margin: 26px 10px

        .progressLabel
            font-size: 10px
            white-space: nowrap

        .progressCounter
            font-size:10px
            width: 100%
            text-align: center

        .progressStarsWrapper
            top: -11px
            left: -10px

        .progressStars
            on-circle($item-count: 8, $circle-size: 120px, $item-size: 20px);

            i
                font-size: 14px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .progressStarsWrapper
            top: -7px;
            left: -6px;

        .progressStars
            on-circle($item-count: 8, $circle-size: 96px, $item-size: 20px);

            i
                font-size: 13px
</style>
